import React, { useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { openUrl } from '@/utils/browserHelper';
import { useTosAcceptance } from '@/hooks/useTosAcceptance';

const TOS_URL = 'https://octoveto.com/tos';
const PRIVACY_URL = 'https://octoveto.com/privacy';

const TosAcceptanceModal: React.FC = () => {
  const { needsAcceptance, loading, acceptTos } = useTosAcceptance();

  // Auto-accept and dismiss after 2 seconds
  useEffect(() => {
    if (!needsAcceptance) return;
    const timer = setTimeout(() => acceptTos(), 2000);
    return () => clearTimeout(timer);
  }, [needsAcceptance, acceptTos]);

  if (loading || !needsAcceptance) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/60 px-4 pb-4 sm:pb-0">
      <div className="w-full max-w-md rounded-2xl bg-white dark:bg-gray-900 p-6 shadow-xl space-y-4">
        {/* Logo / titre */}
        <div className="text-center space-y-1">
          <div className="text-3xl">🐾</div>
          <h2 className="text-xl font-bold text-gray-900 dark:text-white">
            Bienvenue sur OctoVeto
          </h2>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Avant de commencer, veuillez accepter nos conditions.
          </p>
        </div>

        {/* Corps */}
        <div className="rounded-xl bg-gray-50 dark:bg-gray-800 p-4 space-y-3 text-sm text-gray-700 dark:text-gray-300">
          <p>En utilisant OctoVeto, vous acceptez :</p>
          <ul className="space-y-2 pl-2">
            <li>
              <button
                onClick={() => openUrl(TOS_URL)}
                className="text-primary font-medium hover:underline text-left"
              >
                📄 Conditions d'utilisation
              </button>
            </li>
            <li>
              <button
                onClick={() => openUrl(PRIVACY_URL)}
                className="text-primary font-medium hover:underline text-left"
              >
                🔒 Politique de confidentialité
              </button>
            </li>
          </ul>
          <p className="text-xs text-gray-400 dark:text-gray-500 pt-1">
            Vos données sont protégées et ne sont jamais revendues à des tiers.
          </p>
        </div>

        {/* Bouton Accepter */}
        <Button
          className="w-full"
          size="lg"
          onClick={acceptTos}
        >
          ✅ Accepter et continuer
        </Button>

        <p className="text-center text-xs text-gray-400 dark:text-gray-500">
          En appuyant sur "Accepter", vous confirmez avoir lu et accepté nos{' '}
          <button onClick={() => openUrl(TOS_URL)} className="underline">CGU</button>
          {' '}et notre{' '}
          <button onClick={() => openUrl(PRIVACY_URL)} className="underline">politique de confidentialité</button>.
        </p>
      </div>
    </div>
  );
};

export default TosAcceptanceModal;
